import { InvestigationsPayload } from 'app/modules/investigations/types';
import { CaseSearchPayload } from 'app/modules/search/payload';

const BASE = ['cases'] as const;

export const CASE_QUERY_KEYS = {
  getCase: (payload: number, useNewEndpoint: boolean = false) => {
    if (useNewEndpoint) {
      return [...BASE, 'case', payload, 'cached'] as const;
    }
    return [...BASE, 'case', payload] as const;
  },
  listAllCases: () => [...BASE, 'list'] as const,
  listCases: (props: {
    payload: InvestigationsPayload;
    useCacheEndpoint: boolean;
  }) => {
    const { payload, useCacheEndpoint } = props;
    return [
      ...CASE_QUERY_KEYS.listAllCases(),
      payload,
      useCacheEndpoint ? 'cached' : '',
    ] as const;
  },
  getCaseSearch: (payload?: CaseSearchPayload) =>
    payload
      ? ([...BASE, 'search', payload] as const)
      : ([...BASE, 'search'] as const),
};
